import React from 'react'
import { useSelector } from 'react-redux'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'

import UserTableRow from './UserTableRow'

const passesSearchFilter = (user, searchFilter) => {
  if (!searchFilter) return true
  if (user.firstName.toLowerCase().includes(searchFilter.toLowerCase())) return true
  if (user.lastName.toLowerCase().includes(searchFilter.toLowerCase())) return true
  if (user.email.toLowerCase().includes(searchFilter.toLowerCase())) return true
  return false
}

const UsersListView = props => {
  const { onDelete, onEditAccount, searchFilter } = props
  const users = useSelector(state => state.data.users)
  console.log(users);
  const thisUser = useSelector(state => state.data.user)
  const headers = ['User', 'Content Groups', 'Account Role']

  return <Table>
    <TableHead>
      <TableRow>
        {headers.map((header, i) => {
          return <TableCell key={'header' + i}>
            {header}
          </TableCell>
        })}
        {/* padded empty cell to be above options cells */}
        <TableCell padding="checkbox" />
      </TableRow>
    </TableHead>
    <TableBody>
      {users.map(user => {
        if (!passesSearchFilter(user, searchFilter)) return null
        return <UserTableRow
          key={"user:" + user.userId}
          userId={user.userId}
          thisUser={thisUser}
          onDelete={onDelete}
          onEditAccount={onEditAccount}
        />
      })}
    </TableBody>
  </Table>
}

export default UsersListView
